import React, { type ReactNode, useContext, useMemo } from "react";
import { Link } from "react-router-dom";
import { DropdownItem, NavItem, NavLink } from "reactstrap";
import { MenuCurrentPathContext } from "./Menu";
import { MenuNav, MenuNavDepthContext } from "./MenuNav";

export interface IMenuItemProps {
  pathName: string;
  exact?: boolean;
  label: ReactNode;
  onClick?: () => void;
  isActive?: boolean;
  children?: ReactNode;
}

export const MenuItem = ({
  pathName,
  exact = false,
  label,
  children,
  onClick,
  isActive: propIsActive,
}: IMenuItemProps) => {
  const depth = useContext(MenuNavDepthContext);
  const currentPathName = useContext(MenuCurrentPathContext);

  const isActive = useMemo(() => {
    if (propIsActive !== undefined) {
      return propIsActive;
    }
    if (exact) {
      return pathName === currentPathName;
    } else {
      return currentPathName.includes(pathName);
    }
  }, [currentPathName, exact, pathName, propIsActive]);

  // Render Main Menu Bar.
  if (depth === 1) {
    if (children !== undefined) {
      return (
        <MenuNav
          depth={depth}
          toggleLabel={label}
          toggleClassName={isActive ? "active" : ""}
        >
          {children}
        </MenuNav>
      );
    } else {
      return (
        <NavItem>
          <NavLink tag={Link} to={pathName} active={isActive} onClick={onClick}>
            {label}
          </NavLink>
        </NavItem>
      );
    }
  }

  // Render Dropdown Item.
  return (
    <DropdownItem tag={Link} to={pathName} active={isActive} onClick={onClick}>
      {label}
    </DropdownItem>
  );
};
